import Vue from 'vue';
import ToastNotification from '../components/ui/ToastNotification.vue';

const ToastConstructor = Vue.extend(ToastNotification);
let toastPool = [];

function getToastInstance() {
  if (toastPool.length > 0) {
    const instance = toastPool[0];
    toastPool.splice(0, 1);
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement('div')
  });
}

function returnToastInstance(instance) {
  if (instance) {
    toastPool.push(instance);
  }
}

function showToast(options = {}) {
  const duration = options.duration || 3000;
  
  const instance = getToastInstance();
  instance.message = typeof options === 'string' ? options : options.message;
  instance.type = options.type || 'info';
  instance.duration = duration;
  instance.visible = true;
  
  const onClose = () => {
    instance.visible = false;
    document.body.removeChild(instance.$el);
    returnToastInstance(instance);
  };
  
  instance.$on('close', onClose);
  
  document.body.appendChild(instance.$el);
  
  // Force reflow so the enter transition runs.
  instance.$el.offsetHeight;
  
  return {
    close: onClose
  };
}

const toast = {
  info(message, options = {}) {
    return showToast({
      message,
      type: 'info',
      ...options
    });
  },
  success(message, options = {}) {
    return showToast({
      message,
      type: 'success',
      ...options
    });
  },
  warning(message, options = {}) {
    return showToast({
      message,
      type: 'warning',
      ...options
    });
  },
  error(message, options = {}) {
    return showToast({
      message,
      type: 'error',
      ...options
    });
  }
};

export default {
  install(Vue) {
    Vue.prototype.$toast = toast;
  }
};
